export default {
  ROJOU: {
    DOBOKU: {
      HOSOU: 1,
      SHINSHUKUTSUGITE: 2,
      SONOTA: [3, 4, 5, 6, 7],
    }
  },
  KOUKASHITA: {
    KOUKASHITA: {
      HUHOUSENYUUSHA: 1,
    }
  },
}
